import { configureStore } from "@reduxjs/toolkit";
import adminReducer from "features/auth";
import headerReducer from "features/headerSlice";
import sidebarReducer from "features/sidebarSlice";
import mainReducer from "features/mainSlice";
import footerReducer from "features/footerSlice";
import pageTitleReducer from "features/pageTitleSlice";
import vimeoSettingsReducer from "features/vimeoSettingsSlice";
import testimonialsReducer from "features/testimonialsSlice";
import paymentsReducer from "features/paymnetsSlice";
import heroSectionsReducer from "features/heroSectionsSlice";
import productsReducer from "features/productsSlice";
import homepageImagesReducer from "features/homepageImagesSlice";
import homeBannerReducer from "features/homeBannerSlice";
import aboutReducer from "features/aboutSlice";
import aboutStatsReducer from "features/aboutStatsSlice";
import aboutStatsSectionReducer from "features/aboutStatsSectionSlice";
import aboutImagesReducer from "features/aboutImagesSlice";
import metaDetailsReducer from "features/metaDetailsSlice";
import pickupDeliveryReducer from "features/pickupDeliverySlice";
import menuCategoriesReducer from "features/menuCategoriesSlice";
import menuSubcategoriesReducer from "features/menuSubcategoriesSlice";
import contactSettingsReducer from "features/contactSettingsSlice";
import socialMediaLinksReducer from "features/socialMediaLinksSlice";
import privacyPolicyReducer from "features/privacyPolicySlice";

export const store = configureStore({
  reducer: {
    auth: adminReducer,
    sidebar: sidebarReducer,
    header: headerReducer,
    main: mainReducer,
    footer: footerReducer,
    page: pageTitleReducer,
    vimeoSettings: vimeoSettingsReducer,
    testimonials: testimonialsReducer,
    payments: paymentsReducer,
    heroSections: heroSectionsReducer,
    products: productsReducer,
    homepageImages: homepageImagesReducer,
    homeBanner: homeBannerReducer,
    about: aboutReducer,
    aboutStats: aboutStatsReducer,
    aboutStatsSection: aboutStatsSectionReducer,
    aboutImages: aboutImagesReducer,
    metaDetails: metaDetailsReducer,
    pickupDelivery: pickupDeliveryReducer,
    menuCategories: menuCategoriesReducer,
    menuSubcategories: menuSubcategoriesReducer,
    contactSettings: contactSettingsReducer,
    socialMediaLinks: socialMediaLinksReducer,
    privacyPolicy: privacyPolicyReducer,
  },
});
